import React from 'react';

const Features = () => {
  const features = [
    {
      icon: 'fa-chart-bar',
      gradient: 'from-hector-blue to-cyan-400',
      title: 'Custom Affiliate Dashboard',
      description: 'Real-time tracking of referrals, commissions, and payouts'
    },
    {
      icon: 'fa-link',
      gradient: 'from-hector-purple to-pink-400',
      title: 'Unique Referral Link',
      description: 'One link. Unlimited referrals. Built-in tracking'
    },
    {
      icon: 'fa-palette',
      gradient: 'from-green-400 to-cyan-400',
      title: 'Marketing Assets',
      description: 'Email templates, social graphics, case studies, demo videos'
    },
    {
      icon: 'fa-headset',
      gradient: 'from-yellow-400 to-orange-400',
      title: 'Direct Team Access',
      description: 'Slack channel with product, support, and marketing'
    },
    {
      icon: 'fa-user-tie',
      gradient: 'from-blue-400 to-indigo-400',
      title: 'Dedicated Manager',
      description: 'Someone who knows your business, helps optimize outreach'
    },
    {
      icon: 'fa-star',
      gradient: 'from-purple-400 to-pink-400',
      title: 'Early Feature Access',
      description: 'Test products before launch, tell us what sellers need'
    },
    {
      icon: 'fa-bullhorn',
      gradient: 'from-pink-400 to-red-400',
      title: 'Co-Marketing',
      description: 'Webinars, content collaborations, joint case studies'
    },
    {
      icon: 'fa-check-circle',
      gradient: 'from-green-400 to-teal-400',
      title: 'No Approval Process',
      description: 'Commission hits your account every month on schedule'
    }
  ];

  return (
    <section id="features" className="py-20 bg-gradient-to-br from-hector-light-grey via-white to-hector-light-grey">
      <div className="container mx-auto px-6">
        <div className="text-center max-w-4xl mx-auto mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-hector-black mb-6">
            Everything You Need to <span className="bg-gradient-to-r from-hector-blue to-hector-purple bg-clip-text text-transparent">Succeed</span>
          </h2>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div key={index} className="feature-tile bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300">
              <div className={`w-12 h-12 bg-gradient-to-br ${feature.gradient} rounded-lg flex items-center justify-center mb-4`}>
                <i className={`fas ${feature.icon} text-white text-xl`}></i>
              </div>
              <h3 className="text-lg font-bold text-hector-black mb-2">{feature.title}</h3>
              <p className="text-sm text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
        
        {/* CTA */}
        <div className="text-center mt-12 space-y-4">
   <a 
  href="https://hector.partnerstack.com/" 
  target="_blank" 
  rel="noopener noreferrer"
  className="inline-block"
>
  <button
    className="cta-button px-8 py-4 rounded-xl font-semibold text-white text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 w-auto inline-block"
    style={{
      background: "linear-gradient(90deg, #CC2EF4 0%, #3E2EF4 100%)",
    }}
  >
    BECOME A SUCCESSFUL AFFILIATE TODAY
  </button>
</a>

          <p className="text-sm text-gray-600">
            <span className="font-bold text-hector-black">Earn 45-90% commission.</span> Start in 5 minutes.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Features;
